<template>
    <div class="flex flex-row flex-nowrap flex items-center space-x-1 text-base">
        <button
            class="text-gray-500 dark:text-slate-100 relative items-center px-3.5 py-2 font-medium bg-white dark:bg-slate-700 rounded-md hover:bg-gray-50 dark:hover:bg-slate-600"
            :disabled="current <= 1" @click="$emit('input', 0)">
            <i class="fas fa-angle-double-left"></i>
        </button>
        <button
            class="text-gray-500 dark:text-slate-100 relative items-center px-3.5 py-2 font-medium bg-white dark:bg-slate-700 rounded-md hover:bg-gray-50 dark:hover:bg-slate-600"
            :disabled="current <= 1" @click="$emit('input', current - 1)">
            <i class="fas fa-angle-left"></i>
        </button>
        <button class="text-gray-500 dark:text-slate-100 relative items-center font-medium "
            v-if="totalPageCount > props.maxVisibleButtons && current > Math.round(props.maxVisibleButtons  / 2)"
            @click.prevent="focusPre()">
            <div v-show="pre">
                <input type="number" :max="totalPageCount"
                    class="text-base outline-none border-2 border-gray-200 dark:border-transparent dark:hover:border-slate-500 dark:focus-visible:border-slate-500 focus-visible:border-accent-color rounded-md py-1 px-1 dark:bg-gray-700"
                    placeholder="input page number!" ref="pre_input" v-model="jumpPage"
                    @keydown.enter="jumpToPage();post = false" @blur="jumpToPage(); post = false;"></input>
            </div>
            <div v-if="!pre"
                class="text-gray-500 dark:text-slate-100 relative items-center px-3.5 py-2 font-medium bg-white dark:bg-slate-700 rounded-md hover:bg-gray-50 dark:hover:bg-slate-600">
                ...
            </div>
        </button>
        <button @click="gotoPage(visible)"
            class="text-gray-500  dark:text-slate-100 relative items-center px-3.5 py-2 font-medium dark:bg-slate-700 "
            :class="{ 'rounded-md bg-accent-color dark:bg-blue-900 hover:bg-accent-color text-white dark:text-slate-100': visible == current, 'rounded-md bg-white hover:bg-gray-50 dark:hover:bg-slate-600 ' : visible != current}"
            v-for="visible in visiblePages" :key="visible">
            {{ visible }}
        </button>
        <button class="text-gray-500 dark:text-slate-100 relative items-center font-medium "
            v-if="totalPageCount > props.maxVisibleButtons && current < ((totalPageCount - 1) - (props.maxVisibleButtons  / 2))"
            @click.prevent="focusPost()">
            <div v-show="post">
                <input type="number" :max="totalPageCount"
                    class="text-base outline-none border-2 border-gray-200 dark:border-transparent dark:hover:border-slate-500 dark:focus-visible:border-slate-500 focus-visible:border-accent-color rounded-md py-1 px-1 dark:bg-gray-700"
                    placeholder="input page number!" ref="post_input" v-model="jumpPage"
                    @keydown.enter="jumpToPage(); post = false" @blur="jumpToPage(); post = false;"></input>
            </div>
            <div v-if="!post"
                class="text-gray-500 dark:text-slate-100 relative items-center px-3.5 py-2 font-medium bg-white dark:bg-slate-700 rounded-md hover:bg-gray-50 dark:hover:bg-slate-600">
                ...
            </div>
        </button>
        <button
            class="text-gray-500 dark:text-slate-100 relative items-center px-3.5 py-2 font-medium bg-white dark:bg-slate-700 rounded-md hover:bg-gray-50 dark:hover:bg-slate-600"
            :disabled="current >= totalPageCount" @click="$emit('input', current + 1)">
            <i class="fas fa-angle-right"></i>
        </button>
        <button
            class="text-gray-500 dark:text-slate-100 relative items-center px-3.5 py-2 font-medium bg-white dark:bg-slate-700 rounded-md hover:bg-gray-50 dark:hover:bg-slate-600"
            :disabled="current >= totalPageCount" @click="$emit('input', totalPageCount)">
            <i class="fas fa-angle-double-right"></i>
        </button>
        <div class="text-base"
            v-if="!Number.isNaN(currentRecordsRangeFrom) && !Number.isNaN(currentRecordsRangeUntil) && !Number.isNaN(total)">
            <p>
                <translation ident="labels.pagination.records"></translation> {{ currentRecordsRangeFrom }} - {{
                currentRecordsRangeUntil }} <translation ident="labels.pagination.recordsOf"></translation> {{ total }}
            </p>
        </div>
    </div>

</template>

<script setup>
import { defineProps, computed, defineEmits, ref, useTemplateRef, nextTick } from 'vue';

const emit = defineEmits(["input"]);
const props = defineProps({
    pagination: {
        type:  Object,
        required: false,
    },
    take :{
    },
    current: {
    },
    total : {
    },
    maxVisibleButtons: {
        default: 9,
    }
});

const additionals = ref(false);
const pre = ref(false);
const post = ref(false);
const jumpPage = ref("");


const take = computed(() => {
    if(props.take){
        return props.take;
    }
    if(props.pagination.take){
        return props.pagination.take;
    }
    if(props.pagination.pagesize){
        return props.pagination.pagesize
    }
})

const total = computed(() => {
    return props.total ?? props.pagination.total
})

const current = computed(() => {
    return props.current ?? props.pagination.currentPage
})

const totalPageCount = computed(() => {
    return Math.ceil(total.value / take.value);
})




const currentRow = computed(() => {
        return ((current.value - 1) * take.value)
    })
const currentRecordsRangeFrom = computed(() => {
        return currentRow.value + 1
      })
const currentRecordsRangeUntil = computed(() => {
        return Math.min(currentRow.value + take.value, total.value);
      })

const visiblePages = computed(() => {
    if (totalPageCount.value <= props.maxVisibleButtons) {
        return Array.from({ length: totalPageCount.value }, (_, i) => i + 1);
      }

      const visiblePages = [];
      const halfMaxVisibleButtons = Math.floor(props.maxVisibleButtons / 2);

      console.log("halfmax visible", halfMaxVisibleButtons);

      let startPage = Math.max(current.value - halfMaxVisibleButtons, 1);
      let endPage = Math.min(current.value + halfMaxVisibleButtons, totalPageCount.value);
      console.log("start end", startPage, endPage);

      if (startPage <= 2) {
        endPage = Math.min(props.maxVisibleButtons, totalPageCount.value);
      } else if (endPage >= totalPageCount.value - 1) {
        startPage = Math.max(totalPageCount.value - props.maxVisibleButtons + 1, 1);
      }
      console.log("startpage2 ", startPage);
      if (startPage > 1) {
        if(current.value < props.maxVisibleButtons){
            // visiblePages.push(startPage);
        }else{
            // visiblePages.push('...');
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        visiblePages.push(i);
      }

      if (endPage < totalPageCount.value) {
        if (endPage < totalPageCount.value - 1) {
        }else{
            visiblePages.push(totalPageCount.value);
        }
      }

      return visiblePages;
})
const preInput = useTemplateRef('pre_input')
async function focusPre(){
    pre.value = true;
    jumpPage.value = "";
    await nextTick();
    preInput.value.value = "";
    preInput.value.focus();
}
const postInput = useTemplateRef('post_input')
async function focusPost(){
    post.value = true;
     jumpPage.value = "";
    await nextTick();
    postInput.value.value = "";
    postInput.value.focus();
}

function jumpToPage(){
    post.value = false;
    pre.value = false;
    if(jumpPage.value && jumpPage.value != "" && parseInt(jumpPage.value) != 0){
        let jumpTo = parseInt(jumpPage.value);
        if(jumpTo > 0 && jumpTo < totalPageCount.value){
            gotoPage(parseInt(jumpPage.value));
            return;
        }
        if(jumpTo <= 0){
            gotoPage(1);
            return;
        }
        if(jumpTo >= totalPageCount.value){
            gotoPage(totalPageCount.value);
            return;
        }
    }
}

function gotoPage(visible){
    if(visible == "..."){
        additionals.value = true;
    }else{
        emit('input', visible)
    }
}
</script>

